// src/components/Legal/PrivacyPolicy.jsx
import { Box, Typography, Link, Divider } from "@mui/material";

export default function PrivacyPolicy() {
  const today = new Date().toLocaleDateString("fr-FR");

  return (
    <Box
      sx={{
        p: { xs: 2, md: 3 },
        bgcolor: "background.paper",
        color: "text.primary",
        borderRadius: 2,
        border: "1px solid",
        borderColor: "divider",
      }}
    >
      <Typography variant="h4" fontWeight={700} gutterBottom>
        Politique de confidentialité
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Dernière mise à jour : {today}
      </Typography>

      <Typography variant="h6" fontWeight={600} sx={{ mt: 2, mb: 1 }}>
        Quelles données nous traitons
      </Typography>
      <Box component="ul" sx={{ pl: 3, m: 0, lineHeight: 1.8 }}>
        <li>
          <Typography>
            <strong>Compte & authentification :</strong> email, nom (si
            renseigné), photo de profil (facultatif), UID interne.
          </Typography>
        </li>
        <li>
          <Typography>
            <strong>Contenu des tickets :</strong> titre, description,
            priorités, pièces jointes, activités liées au ticket.
          </Typography>
        </li>
        <li>
          <Typography>
            <strong>Newsletter (facultatif) :</strong> adresse email et date
            d’inscription.
          </Typography>
        </li>
        <li>
          <Typography>
            <strong>Données techniques :</strong> journaux techniques (erreurs
            client), horodatages, identifiants internes de projet/organisation.
          </Typography>
        </li>
        <li>
          <Typography>
            <strong>Paiements (Premium) :</strong> gérés par Stripe. Nous ne
            stockons <em>pas</em> vos numéros de carte ; nous conservons les
            références d’abonnement et les statuts pour fournir le service.
          </Typography>
        </li>
      </Box>

      <Typography variant="h6" fontWeight={600} sx={{ mt: 3, mb: 1 }}>
        Sous-traitants et services utilisés
      </Typography>
      <Box component="ul" sx={{ pl: 3, m: 0, lineHeight: 1.8 }}>
        <li>
          <Typography>
            <strong>Firebase (Google Cloud) :</strong> Auth, Firestore, Storage,
            Hosting, pour l’authentification, la base de données temps réel, le
            stockage des pièces jointes et l’hébergement.
          </Typography>
        </li>
        <li>
          <Typography>
            <strong>Stripe :</strong> traitement des paiements et gestion des
            abonnements.
          </Typography>
        </li>
      </Box>
      <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
        Ces prestataires peuvent traiter des données dans l’UE et/ou aux
        États-Unis. Des mécanismes contractuels (ex. Clauses Contractuelles
        Types) encadrent les transferts hors UE.
      </Typography>

      <Typography variant="h6" fontWeight={600} sx={{ mt: 3, mb: 1 }}>
        Durées de conservation
      </Typography>
      <Box component="ul" sx={{ pl: 3, m: 0, lineHeight: 1.8 }}>
        <li>
          <Typography>
            <strong>Compte utilisateur :</strong> pendant la durée d’utilisation
            et jusqu’à <strong>24 mois</strong> après la dernière activité (ou
            suppression sur demande).
          </Typography>
        </li>
        <li>
          <Typography>
            <strong>Tickets & pièces jointes :</strong> tant que le projet est
            actif, puis archivage/suppression sur demande de l’administrateur.
          </Typography>
        </li>
        <li>
          <Typography>
            <strong>Newsletter :</strong> jusqu’à désinscription (opt-out) ou
            suppression sur demande.
          </Typography>
        </li>
        <li>
          <Typography>
            <strong>Journaux techniques :</strong> jusqu’à{" "}
            <strong>12 mois</strong>.
          </Typography>
        </li>
        <li>
          <Typography>
            <strong>Données de facturation :</strong> conformément aux
            obligations comptables applicables (jusqu’à <strong>10 ans</strong>{" "}
            dans certains pays, ex. France).
          </Typography>
        </li>
      </Box>

      <Typography variant="h6" fontWeight={600} sx={{ mt: 3, mb: 1 }}>
        Vos droits (RGPD)
      </Typography>
      <Box component="ul" sx={{ pl: 3, m: 0, lineHeight: 1.8 }}>
        <li>
          <Typography>
            <strong>Accès</strong> à vos données et <strong>portabilité</strong>
            .
          </Typography>
        </li>
        <li>
          <Typography>
            <strong>Rectification</strong> ou <strong>suppression</strong> de
            vos données personnelles.
          </Typography>
        </li>
        <li>
          <Typography>
            <strong>Limitation</strong> et <strong>opposition</strong> à
            certains traitements.
          </Typography>
        </li>
        <li>
          <Typography>
            <strong>Retrait du consentement</strong> (ex. newsletter) à tout
            moment, sans effet rétroactif.
          </Typography>
        </li>
      </Box>

      <Typography variant="h6" fontWeight={600} sx={{ mt: 3, mb: 1 }}>
        Nous contacter
      </Typography>
      <Typography sx={{ mb: 2 }}>
        Pour exercer vos droits ou poser une question, utilisez le bouton{" "}
        <strong>“Contactez nous”</strong> dans votre profil.
      </Typography>

      <Divider sx={{ my: 2 }} />

      <Typography variant="body2" color="text.secondary">
        Remarque : nous n’utilisons pas de cookies/traceurs à des fins
        marketing/analytics sans votre consentement. Si nous ajoutons des
        mesures d’audience (ex. Google Analytics), un mécanisme de consentement
        préalable sera déployé.
      </Typography>
    </Box>
  );
}
